import {
  cloneAnnotationInteractions,
  cloneAnnotationStateRecord,
  cloneAnnotationTriggers,
} from '../lib/worldAnnotationRuntime';
import type { BrushTile, CompositeStamp, TileBrush, TileReference } from '../types/levelEditor';
import type { WorldAnnotation } from '../types/worldAnnotation';

export const cloneTileReference = (tile: TileReference): TileReference => ({ ...tile });

export const cloneAnnotation = (annotation: WorldAnnotation): WorldAnnotation => ({
  ...annotation,
  position: { ...annotation.position },
  ...(annotation.size ? { size: { ...annotation.size } } : {}),
  ...(annotation.tags ? { tags: [...annotation.tags] } : {}),
  ...(annotation.doorTarget ? { doorTarget: { ...annotation.doorTarget } } : {}),
  ...(cloneAnnotationInteractions(annotation.interactions)
    ? { interactions: cloneAnnotationInteractions(annotation.interactions) }
    : {}),
  ...(cloneAnnotationStateRecord(annotation.state)
    ? { state: cloneAnnotationStateRecord(annotation.state) }
    : {}),
  ...(cloneAnnotationTriggers(annotation.triggers)
    ? { triggers: cloneAnnotationTriggers(annotation.triggers) }
    : {}),
});

export const cloneAnnotations = (annotations: WorldAnnotation[] | undefined): WorldAnnotation[] =>
  Array.isArray(annotations) ? annotations.map(cloneAnnotation) : [];

const cloneBrushTile = (entry: BrushTile): BrushTile => ({
  offsetX: entry.offsetX,
  offsetY: entry.offsetY,
  tile: cloneTileReference(entry.tile),
});

export const cloneBrush = (brush: TileBrush): TileBrush => ({
  width: brush.width,
  height: brush.height,
  tiles: brush.tiles.map(cloneBrushTile),
});

export const cloneCompositeStamp = (stamp: CompositeStamp): CompositeStamp => ({
  width: stamp.width,
  height: stamp.height,
  layers: stamp.layers.map((layer) => ({
    layerName: layer.layerName,
    tiles: layer.tiles.map(cloneBrushTile),
  })),
});
